/**
 * 外包（供应商端）充值单详情/审批抽屉（薄 wrapper）。
 * 复用公共层 RechargeConfirmView：isExternal=true，仅 SUPPLIER_CONFIRM 可上传附件，
 * PLANNER/OPTIMIZER/PRINCIPAL_CONFIRM 只读「等待内部审批」；待发起态可废弃。
 */
import React from 'react';
import withFunctionCall from '@mpc/common/src/utils/withFunctionCall';
import { RechargeConfirmView } from '@mpc/common/src/features/RechargeRefund/Drawer/RechargeConfirmView';

export interface RechargeDetailDrawerProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess?: () => void;
  orderId?: number;
}

const RechargeDetailDrawer: React.FC<RechargeDetailDrawerProps> = ({
  visible,
  onCancel,
  onSuccess,
  orderId,
}) => (
  <RechargeConfirmView
    visible={visible}
    onCancel={onCancel}
    onSuccess={onSuccess}
    orderId={orderId as number}
    isExternal
  />
);

export default withFunctionCall(RechargeDetailDrawer);
